import { TFunction } from "i18next";

import { capitalize } from "@helpers/general";
import {
    PrinterRowData,
    PrinterSettingConfig,
    PRINTER_MODE_OF_SALE_PATH,
} from "@components/Common/PrinterSetting";

const SAVE_PATH = "/settings/application/kds/printer/setting";
const PERIPHERAL_KEY = "Peripheral";
const APPLICATION_KEY = "Application";

function buildTitle(t: TFunction) {
    return (rowData: PrinterRowData): string => {
        const application =
            (rowData[APPLICATION_KEY] as string | undefined) ?? "";
        const peripheral =
            (rowData[t(PERIPHERAL_KEY)] as string | undefined) ?? "";
        return `${capitalize(t("Settings"))} ${application} - ${peripheral}`;
    };
}

export function buildKdsPrinterSettingConfig(
    t: TFunction
): PrinterSettingConfig {
    return {
        appId: "KDS",
        appNameField: "applicationDesignation",
        endpoints: {
            save: `${process.env.REACT_APP_API_V2_URL}${SAVE_PATH}`,
            fetchModeOfSale: `${process.env.REACT_APP_API_V2_URL}${PRINTER_MODE_OF_SALE_PATH}`,
        },
        features: {
            confirmBeforeSave: false,
            includeUuidUser: true,
            includeOperatorId: true,
        },
        titleTemplate: buildTitle(t),
    };
}
